export const defaultFaq = [
    {
        question: "How does HouseSit Match ensure sitter reliability?",
        answer: "We use professional identity verification services to confirm every sitter's authenticity. Additionally, our platform features genuine reviews from completed sits, so you can trust the references provided.",
    },
    {
        question: "Is house sitting really free?",
        answer: "Yes! House and pet sitting are exchanges of services. Sitters provide care for your home and pets in return for accommodation, making it a cost-effective arrangement for both parties.",
    },
    {
        question: "What if I have multiple properties?",
        answer: "Premium members can list up to three properties per account, making it easy to manage care for holiday homes and main residences alike.",
    },
    {
        question: "How does HouseSit Match protect my data?",
        answer: "We store all member data securely in the UK and comply with GDPR regulations. Your information will never be sold or shared without your consent.",
    },
    {
        question: "Can I customise my house sitting advert?",
        answer: "Absolutely! Premium accounts allow for detailed profiles, video introductions, and up to seven images to showcase your home and pets to potential sitters.",
    },
];